import { Link } from "react-router-dom";
import { MapPin, Mail, Clock } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-court-surface/60">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <div className="font-display font-extrabold uppercase tracking-tight text-2xl mb-3">
            Theo <span className="text-court-amber">Basketball Lab</span>
          </div>
          <p className="text-sm text-zinc-400 leading-relaxed max-w-xs">
            Elite skill development for middle school through Division 1 athletes — boys and girls — in private gyms across Alameda, CA.
          </p>
        </div>
        <div>
          <h4 className="font-mono text-xs uppercase tracking-widest text-zinc-500 mb-4">Train With Theo</h4>
          <ul className="space-y-2 text-sm text-zinc-300">
            <li><Link data-testid="footer-schedule-link" to="/schedule" className="hover:text-court-amber transition-colors">Schedule & Booking</Link></li>
            <li><Link data-testid="footer-plans-link" to="/plans" className="hover:text-court-amber transition-colors">Training Plans Vault</Link></li>
            <li><Link data-testid="footer-camp-link" to="/summer-camp" className="hover:text-court-amber transition-colors">Summer 2027 Camp</Link></li>
            <li><Link data-testid="footer-about-link" to="/about" className="hover:text-court-amber transition-colors">About Coach Theo</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-mono text-xs uppercase tracking-widest text-zinc-500 mb-4">The Lab</h4>
          <ul className="space-y-3 text-sm text-zinc-300">
            <li className="flex items-center gap-3"><MapPin size={15} className="text-court-amber shrink-0" /> Nothing But Net Gym • 590 Whitney St, San Leandro, CA 94577</li>
            <li className="flex items-center gap-3"><Mail size={15} className="text-court-amber shrink-0" /> trainingcoachtheo@gmail.com</li>
            <li className="flex items-center gap-3"><Clock size={15} className="text-court-amber shrink-0" /> Weekdays 3:30–8 PM • Sat 9 AM–3 PM</li>
          </ul>
          <p className="mt-5 text-xs font-mono uppercase tracking-wider text-zinc-500">Pay in person — cash, Zelle, or Venmo. No online payment needed.</p>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs font-mono uppercase tracking-widest text-zinc-600">
        © 2026 Theo Basketball Lab • Alameda, CA • Built for the next generation
      </div>
    </footer>
  );
}
